import moment from "moment";

export function calculateJulianDate(date: string) {
    const year = moment(date).get("year");
    const startOfYear = moment(date).startOf("year").format("YYYY-MM-DD");
    let daysCount = moment(date).diff(startOfYear, "days") + 1;
    const daysTotal = ("000" + daysCount).substr(-3);
    return (year.toString() + daysTotal);
}